var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Data } from 'slate';
import React from 'react';
import createSlateBasePlugin from './createBasePlugin';
function createComponentPluginWithDefinition(pluginDefintion) {
    return __assign(__assign({}, createSlateBasePlugin(__assign(__assign({}, pluginDefintion), { pluginType: 'component' }))), { deserialize: pluginDefintion.deserialize
            ? // tslint:disable-next-line:no-any
                function (el, next) {
                    var tagName = el.tagName.toLowerCase();
                    if (tagName !== pluginDefintion.deserialize.tagName) {
                        return;
                    }
                    return {
                        object: pluginDefintion.object,
                        type: pluginDefintion.type,
                        nodes: next(el.childNodes),
                        data: pluginDefintion.deserialize.getData
                            ? Data.create(pluginDefintion.deserialize.getData(el))
                            : undefined,
                    };
                }
            : null, serialize: function (
        // tslint:disable-next-line:no-any
        node, 
        // tslint:disable-next-line:no-any
        children) {
            if (node.object !== pluginDefintion.object) {
                return;
            }
            if (node.type !== pluginDefintion.type) {
                return;
            }
            var Component = pluginDefintion.Component;
            return React.createElement(Component, { data: node.data, children: children });
        }, renderMark: function (props, editor, next) {
            var attributes = props.attributes, children = props.children, mark = props.mark;
            if (mark.type !== pluginDefintion.type) {
                return next();
            }
            if (mark.object !== pluginDefintion.object) {
                return next();
            }
            var Component = pluginDefintion.Component;
            return (React.createElement(Component, { data: mark.data, children: children, attributes: attributes }));
        }, renderBlock: function (props, editor, next) {
            var children = props.children, node = props.node;
            if (node.type !== pluginDefintion.type) {
                return next();
            }
            if (node.object !== pluginDefintion.object) {
                return next();
            }
            var Component = pluginDefintion.Component;
            return React.createElement(Component, { data: node.data, children: children });
        }, renderInline: function (props, editor, next) {
            var children = props.children, node = props.node;
            if (node.type !== pluginDefintion.type) {
                return next();
            }
            if (node.object !== pluginDefintion.object) {
                return next();
            }
            var Component = pluginDefintion.Component;
            return React.createElement(Component, { data: node.data, children: children });
        } });
}
function createComponentPlugin(definition) {
    return function (customize) {
        if (customize) {
            return createComponentPluginWithDefinition(customize(definition));
        }
        return createComponentPluginWithDefinition(definition);
    };
}
export default createComponentPlugin;
//# sourceMappingURL=createComponentPlugin.js.map